import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const url = `${apiUrl}suppliers`;

export const suppliersGet = (includeInactive) => {
    const query = includeInactive ? "?includeInactive=true" : "";
    return axios.get(`${url}${query}`);
};

export const supplierGetById = (id) =>
    axios.get(`${url}/${id}`);

export const supplierInsert = (data) =>
    axios.post(`${url}`, data);

export const supplierUpdate = (id, data) =>
    axios.put(`${url}/${id}`, data);

export const supplierDelete = (id) =>
    axios.delete(`${url}/${id}`);

export const requestSupplierContactsGet = (supplierId) =>
    axios.get(`${url}/${supplierId}/contacts`);

export const requestSupplierContactsCreate = (supplierId, data) =>
    axios.post(`${url}/${supplierId}/contacts`, data);

export const requestSupplierContactsGetById = (supplierId, contactId) =>
    axios.get(`${url}/${supplierId}/contacts/${contactId}`);

export const requestSupplierContactsUpdateById = (supplierId, contactId, data) =>
    axios.put(`${url}/${supplierId}/contacts/${contactId}`, data);

export const requestSupplierContactsDeleteById = (supplierId, contactId) =>
    axios.delete(`${url}/${supplierId}/contacts/${contactId}`);

export const requestSupplierGetUsers = (supplierId) =>
    axios.get(`${url}/${supplierId}/users`);

export const requestSupplierGetUsersById = (userId) =>
    axios.get(`${url}/users/${userId}`);

export const requestSupplierCreateUsers = (supplierId, data) =>
    axios.post(`${url}/${supplierId}/users`, data);

export const requestSupplierUpdateUsers = (supplierId, userId, data) =>
    axios.put(`${url}/${supplierId}/users/${userId}`, data);

export const requestSupplierDeleteUsers = (userId) =>
    axios.delete(`${url}/users/${userId}`);
